// placements for each environment,...and now for each action type...
interface IRewardedPlacements {
    coins: string;
    life: string;
    skipMission: string;
    wheel: string;
    [key: string]: string;
}

interface IInterstitialPlacements {
    first: string;
    second: string;
    [key: string]: string;
}

interface IAdPlacements {
    rewarded: IRewardedPlacements;
    interstitial: IInterstitialPlacements;
}

export const getAdPlacments = (): IAdPlacements => {
    return { rewarded: setRewarded(), interstitial: setInterstitial() };
};

export const getAdByType = (type: string) => {
    if (type === 'i') {
        return getAdPlacments().interstitial;
    }
    return getAdPlacments().rewarded;
};

export const getAdByAction = (
    action: string,
    group: IRewardedPlacements | IInterstitialPlacements
): string => {
    return group[action];
};

const setRewarded = () => {
    // switch node env
    return productionRewards;
};

const setInterstitial = () => {
    // switch node env
    return productionInterstitial;
};

const productionRewards: IRewardedPlacements = {
    coins: '1869354289823409_1976036652488505',
    life: '1869354289823409_1976036935821810',
    skipMission: '1869354289823409_1976037549155082',
    wheel: '1869354289823409_1976037239155113',
    rewardedPresent: '1869354289823409_1987665264658977',
};

const productionInterstitial: IInterstitialPlacements = {
    first: '1869354289823409_1976033209155516',
    second: '1869354289823409_1976035599155277',
};
